export const transition = { 
    duration: .5, 
    ease: [.56, .03, .12, 1.04]
};

export const btnVariants = {
    initial: {
        backgroundColor: '#fff',
        color: '#161d2d'
    },
    animate: {
        backgroundColor: '#161d2d',
        color: '#fff'
    }
}

export const textVariants = { 
    initial: { 
        opacity: 0,
        y: '100%'
    }, 
    animate: { 
        opacity: 1,
        y: 0
    }
};

export const iconVariants = {
    initial: {
        opacity: 1,
        y: 0
    },
    animate: {
        opacity: 0,
        y: '-100%'
    }
}